import IconElement from './IconElement';
import IconElementDefinition from './IconElementDefinition';
import IconElementMetaData from './IconElementMetaData';

export default {
  IconElement: IconElement,
  IconElementDefinition: IconElementDefinition,
  IconElementType: IconElementMetaData.type
};
